import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper } from "@mui/material";
import { BankStatements, SectionHeader, StepActions, UploadCard, PageHeader } from "@components/ui_v2";
import { DOCUMENTS_CATALOG, PATHS_TOFU_V2 } from "@helpers/constantes";
import { DocumentResponse } from "@interfaces/response";

/**
 * Los estados de cuenta bancarios no van aquí: son un bloque aparte
 * (`BankStatements`) porque se declaran por cuenta y con tres archivos cada una.
 */
const DOCUMENTOS = [
  {
    key: "constancia",
    title: "Constancia de Situación Fiscal",
    sub: "Del SAT, vigente del ejercicio en curso",
    required: true,
    fileCode: DOCUMENTS_CATALOG.constancia_situacion_fiscal.code,
  },
  {
    key: "estadosParciales",
    title: "Estados financieros internos parciales",
    sub: "Opcional · del año en curso (enero al mes más reciente)",
    required: false,
    fileCode: DOCUMENTS_CATALOG.ultimo_cierre_parcial.code,
  },
  {
    key: "estadosEjercicio",
    title: "Estados financieros del último ejercicio",
    sub: "Opcional · ejercicio fiscal completo anterior",
    required: false,
    fileCode: DOCUMENTS_CATALOG.cierre_anual.code,
  },
];

export const CargaDocumentos = () => {
  const navigate = useNavigate();
  const [documentos, setDocumentos] = useState<Record<string, DocumentResponse | undefined>>({});
  const [estadosCuentaCompletos, setEstadosCuentaCompletos] = useState(false);

  const onBack = () => navigate(PATHS_TOFU_V2.decisionIngreso.path);
  const onNext = () => navigate(PATHS_TOFU_V2.nipBuro.path);

  const setDocumento = (key: string, documento: DocumentResponse | undefined) =>
    setDocumentos((prev) => ({ ...prev, [key]: documento }));
  // Los documentos opcionales no bloquean el avance; los estados de cuenta sí.
  const requeridosListos = DOCUMENTOS.filter((d) => d.required).every((d) => documentos[d.key]);

  return (
    <Box>
      <PageHeader
        eyebrow="Empresa · Documentos"
        title="Sube los documentos de tu empresa"
        subtitle="Necesitamos estos cuatro documentos para evaluar tu solicitud de crédito."
      />

      <Paper variant="lendia_paper">
        <SectionHeader label="Documentos requeridos" first />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {DOCUMENTOS.map((d) => (
            <UploadCard
              key={d.key}
              title={d.title}
              sub={d.sub}
              required={d.required}
              fileCode={d.fileCode}
              document={documentos[d.key]}
              onDocumentChange={(documento) => setDocumento(d.key, documento)}
            />
          ))}

          <BankStatements onCompleteChange={setEstadosCuentaCompletos} />
        </Box>
      </Paper>

      <StepActions
        onBack={onBack}
        onNext={onNext}
        nextDisabled={!requeridosListos || !estadosCuentaCompletos}
        backTestId="carga-documentos-back-button"
        nextTestId="carga-documentos-continue-button"
      />
    </Box>
  );
};
